import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@mui/material/TextField';
import { Button, DialogActions, FormControl, FormHelperText } from "@material-ui/core";
import {
  voidInventoryUpdate
} from "./../../dashboard/actions/dashboardAction";
import { trim } from "lodash";
import { toast } from "react-toastify";

export default function VoidInventory(props) {

  const { open, handleClose, inventory, updateInventoryDetails } = props;
  const [reason, setReason] = React.useState('');
  const [errorText, setErrorText] = React.useState('')
  const validateReason = () => {
    if (reason.length >= 1000) {
      setErrorText('Reason cannot exceed 1000 characters.');
      return;
    }
    if (trim(reason) !== '') {
      updateInventoryDetails(reason)
    }
    else {
      setErrorText('Void reason should not be blank.')
    }
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={'sm'}

    >
      <DialogTitle >
        Void Inventory
        <IconButton onClick={() => { handleClose() }} style={{ float: 'right' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div> Are you sure you want to <b>Void</b> the inventory? </div>
        <div><FormControl style={{ width: '400px', margin: '20px 0px' }}>
          <TextField
            id="outlined-multiline-flexible"
            label="Please enter the reason for void"
            multiline
            maxRows={4}
            required={true}
            style={{ width: '400px !important' }}
            onChange={(e) => { setReason(e.target.value); setErrorText('') }}
          />
          <FormHelperText className="error-o">{errorText}</FormHelperText>

        </FormControl></div>
      </DialogContent>
      <DialogActions>
        <Button color="primary" autoFocus onClick={handleClose}>
          Cancel
        </Button>
        <Button color="primary" onClick={validateReason}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}
